/* eslint-disable no-new */
import UAParser from 'ua-parser-js'
import notificationIcon from '~/assets/icons/icon-notification.png'
import notificationSound from '~/assets/sounds/notification.mp3'
import Logger from '~/services/Logger'

const isSupported = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window

const logger = new Logger('notifications.ts')

export const canSendNotification = () => {
  if (!isSupported()) {
    return false
  }
  const UserAgentInstance = new UAParser(window.navigator.userAgent)

  // an undefined device type means the device is a browser
  // https://github.com/duskload/react-device-detect/blob/54ce6cfbed0479691c45aa0371e4afdfaaae74f8/src/constants/constants.js#L8
  return UserAgentInstance.getDevice().type === undefined
}

interface SendNotificationParams {
  title: string
  body: string
  onClick?: () => void
  playSound?: boolean
}
export const sendNotification = async ({
  title,
  body,
  onClick,
  playSound,
}: SendNotificationParams) => {
  if (!canSendNotification()) return
  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      body,
      icon: notificationIcon,
    })

    notification.onclick = () => {
      onClick?.()
      notification.close()
    }

    if (playSound) {
      const sound = new Audio(notificationSound)

      try {
        await sound.play()
      } catch (error: unknown) {
        // do nothing, if the sound can't play...whatever
        logger.debug(`Error playing notification sound: ${error}`)
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        // The tab has become visible so clear the now-stale Notification.
        notification.close()
      }
    })
  }
}
